import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900 flex" }
const _hoisted_2 = { class: "fixed inset-0 flex" }
const _hoisted_3 = { class: "flex items-center justify-between h-16 px-6 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_4 = { class: "p-6 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = { class: "w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center" }
const _hoisted_7 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_8 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_9 = { class: "mt-6 px-3 overflow-y-auto" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = ["onClick", "aria-current"]
const _hoisted_12 = {
  key: 0,
  class: "ml-auto bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-300 text-xs px-2 py-1 rounded-full"
}
const _hoisted_13 = { class: "mt-8" }
const _hoisted_14 = { class: "mt-3 space-y-1" }
const _hoisted_15 = { class: "mt-auto p-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_16 = {
  id: "admin-sidebar-desktop",
  class: "hidden lg:flex lg:w-64 lg:flex-col bg-white dark:bg-gray-800 shadow-lg"
}
const _hoisted_17 = { class: "relative flex min-h-screen flex-col" }
const _hoisted_18 = { class: "p-6 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_19 = { class: "flex items-center space-x-3" }
const _hoisted_20 = { class: "w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center" }
const _hoisted_21 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_22 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_23 = { class: "mt-6 px-3 flex-1 overflow-y-auto" }
const _hoisted_24 = { class: "space-y-1" }
const _hoisted_25 = ["onClick", "aria-current"]
const _hoisted_26 = {
  key: 0,
  class: "ml-auto bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-300 text-xs px-2 py-1 rounded-full"
}
const _hoisted_27 = { class: "mt-8" }
const _hoisted_28 = { class: "mt-3 space-y-1" }
const _hoisted_29 = { class: "mt-auto p-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_30 = { class: "flex-1 flex flex-col min-w-0" }
const _hoisted_31 = { class: "sticky top-0 z-30 bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700" }
const _hoisted_32 = { class: "flex items-center justify-between h-16 px-6" }
const _hoisted_33 = { class: "flex items-center space-x-4" }
const _hoisted_34 = ["aria-expanded"]
const _hoisted_35 = { class: "text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_36 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_37 = { class: "flex items-center space-x-4" }
const _hoisted_38 = {
  class: "p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700",
  "aria-label": "Notifications"
}
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { class: "flex-1 p-6 overflow-auto" }
const _hoisted_41 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_42 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_43 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_44 = { class: "bg-white dark:bg-gray-800 shadow rounded-lg p-6" }
const _hoisted_45 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { key: 4 }
const _hoisted_50 = {
  key: 5,
  class: "space-y-6"
}
const _hoisted_51 = {
  key: 6,
  class: "space-y-6"
}

import { useRouter } from 'vue-router'
import {
  Bars3Icon,
  XMarkIcon,
  HomeIcon,
  PhotoIcon,
  FolderIcon,
  UsersIcon,
  ChartBarIcon,
  CogIcon,
  UserIcon,
  BellIcon,
  SunIcon,
  MoonIcon,
  PlusIcon,
  FolderPlusIcon,
  ArrowRightStartOnRectangleIcon,
  DocumentTextIcon
} from '@heroicons/vue/24/outline';
import {
  Switch,
  SwitchGroup,
  SwitchLabel
} from '@headlessui/vue';
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import { useAdmin } from '../composables/useAdmin';
import { authService } from '../firebase/services/authService';
import { ref, computed, onMounted, defineAsyncComponent } from 'vue';

// Async components
type Theme = 'light' | 'dark' | 'system';

// Extend Window interface to include __setPreferredTheme
declare global {
  interface Window {
    __setPreferredTheme?: (theme: Theme) => void;
  }
}

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboard',
  setup(__props) {

const WallpaperManagement = defineAsyncComponent(() =>
  import('../components/WallpaperManagement.vue')
);

const WallpaperStats = defineAsyncComponent(() =>
  import('../components/WallpaperStats.vue')
);

const WallpaperUploadModal = defineAsyncComponent(() =>
  import('../components/WallpaperUploadModal.vue')
);

const CategoryModal = defineAsyncComponent(() =>
  import('../components/CategoryModal.vue')
);

const CategoryManagement = defineAsyncComponent(() =>
  import('../components/CategoryManagement.vue')
);

const AdminUserManagement = defineAsyncComponent(() =>
  import('../components/AdminUserManagement.vue')
);

const BlogManagement = defineAsyncComponent(() =>
  import('../components/admin/BlogManagement.vue')
);

const BlogStatsWidget = defineAsyncComponent(() =>
  import('../components/admin/BlogStatsWidget.vue')
);

const TopWallpapersWidget = defineAsyncComponent(() =>
  import('../components/admin/TopWallpapersWidget.vue')
);

const RecentActivityWidget = defineAsyncComponent(() =>
  import('../components/admin/RecentActivityWidget.vue')
);

// Theme type for better type safety
const router = useRouter();

// Admin management
const { currentAdminUser } = useAdmin();

// State
const sidebarOpen = ref(false);
const activeSection = ref('dashboard');
const showUploadModal = ref(false);
const showCategoryModal = ref(false);
const isDark = ref(false);
const wallpaperManagementKey = ref(0); // Key to force refresh of WallpaperManagement component

// Remove unused recentActivities since we now use RecentActivityWidget

// Navigation items
const navigationItems = computed(() => [
  {
    id: 'dashboard',
    name: 'Dashboard',
    icon: HomeIcon,
    badge: null
  },
  {
    id: 'wallpapers',
    name: 'Wallpapers',
    icon: PhotoIcon,
    badge: null
  },
  {
    id: 'categories',
    name: 'Categories',
    icon: FolderIcon,
    badge: null
  },
  {
    id: 'blog',
    name: 'Blog',
    icon: DocumentTextIcon,
    badge: null
  },
  {
    id: 'users',
    name: 'Users & Admins',
    icon: UsersIcon,
    badge: null
  },
  {
    id: 'analytics',
    name: 'Analytics',
    icon: ChartBarIcon,
    badge: null
  },
  {
    id: 'settings',
    name: 'Settings',
    icon: CogIcon,
    badge: null
  }
]);

// Computed
const currentSectionTitle = computed(() => {
  const section = navigationItems.value.find((item) => item.id === activeSection.value);
  return section?.name || 'Dashboard';
});

const currentSectionDescription = computed(() => {
  const descriptions: Record<string, string> = {
    dashboard: 'Overview of your wallpaper application',
    wallpapers: 'Manage and organize wallpapers',
    categories: 'Create and manage wallpaper categories',
    blog: 'Create and manage blog posts',
    users: 'Manage admin users and permissions',
    analytics: 'View detailed analytics and reports',
    settings: 'Configure application settings'
  };
  return descriptions[activeSection.value as keyof typeof descriptions] || '';
});

// Methods
const toggleTheme = () => {
  isDark.value = !isDark.value;
  if (isDark.value) {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  }

  // Call global theme handler if available
  if (window.__setPreferredTheme) {
    window.__setPreferredTheme(isDark.value ? 'dark' : 'light');
  }
};

const handleSignOut = async (): Promise<void> => {
  try {
    await authService.signOut();
    router.push('/');
  } catch (error) {
    console.error('Error signing out:', error);
  }
};

const handleMobileSectionChange = (sectionId: string): void => {
  sidebarOpen.value = false;
  activeSection.value = sectionId;
};

const openMobileUploadModal = (): void => {
  sidebarOpen.value = false;
  showUploadModal.value = true;
};

const openMobileCategoryModal = (): void => {
  sidebarOpen.value = false;
  showCategoryModal.value = true;
};

const handleMobileSignOut = async (): Promise<void> => {
  sidebarOpen.value = false;
  await handleSignOut();
};

const handleUploadSuccess = () => {
  showUploadModal.value = false;
  // Force refresh of the WallpaperManagement component by changing its key
  wallpaperManagementKey.value += 1;
};

const handleCategorySuccess = () => {
  showCategoryModal.value = false;
  // Refresh data if needed
};

const handleCreatePost = () => {
  activeSection.value = 'blog';
  // The BlogManagement component will handle opening the editor
};

const handleViewBlog = () => {
  // Open blog in new tab
  window.open('/blog', '_blank');
};

// Initialize
onMounted(async () => {
  // Check initial theme
  const savedTheme = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  isDark.value = savedTheme === 'dark' || (!savedTheme && prefersDark);

  if (isDark.value) {
    document.documentElement.classList.add('dark');
  }

  // Check admin authentication
  if (!currentAdminUser.value) {
    console.log('No admin user found, redirecting to admin login...');
    router.push('/admin');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-50 lg:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1)
              ])),
              _: 1,
              __: [13]
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    id: "admin-sidebar",
                    class: "relative flex w-64 max-w-full flex-col bg-white dark:bg-gray-800 shadow-lg"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex items-center space-x-2" }, [
                          _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center" }, [
                            _createElementVNode("span", { class: "text-white font-bold text-sm" }, "A")
                          ]),
                          _createElementVNode("span", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, "Admin Panel")
                        ], -1)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false)),
                          "aria-label": "Close sidebar",
                          class: "p-1 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                        }, [
                          _createVNode(_unref(XMarkIcon), { class: "w-6 h-6" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(UserIcon), { class: "w-6 h-6 text-purple-600 dark:text-purple-400" })
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(currentAdminUser)?.displayName || 'Admin User'), 1),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(currentAdminUser)?.role || 'Administrator'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("nav", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationItems.value, (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: item.id,
                              type: "button",
                              onClick: ($event: any) => (handleMobileSectionChange(item.id)),
                              "aria-current": activeSection.value === item.id ? 'page' : undefined,
                              class: _normalizeClass([
                    'w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors',
                    activeSection.value === item.id
                      ? 'bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                  ])
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5 mr-3" })),
                              _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                              (item.badge)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.badge), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_11))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider" }, " Quick Actions ", -1)),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: openMobileUploadModal,
                              class: "w-full flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                            }, [
                              _createVNode(_unref(PlusIcon), { class: "w-5 h-5 mr-3" }),
                              _cache[15] || (_cache[15] = _createTextVNode(" Upload Wallpaper ", -1))
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: openMobileCategoryModal,
                              class: "w-full flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                            }, [
                              _createVNode(_unref(FolderPlusIcon), { class: "w-5 h-5 mr-3" }),
                              _cache[16] || (_cache[16] = _createTextVNode(" Add Category ", -1))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: handleMobileSignOut,
                          class: "w-full flex items-center px-3 py-2 text-sm font-medium text-red-600 dark:text-red-400 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
                        }, [
                          _createVNode(_unref(ArrowRightStartOnRectangleIcon), { class: "w-5 h-5 mr-3" }),
                          _cache[18] || (_cache[18] = _createTextVNode(" Sign Out ", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("aside", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"flex items-center justify-between h-16 px-6 border-b border-gray-200 dark:border-gray-700\"><div class=\"flex items-center space-x-2\"><div class=\"w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center\"><span class=\"text-white font-bold text-sm\">A</span></div><span class=\"text-lg font-semibold text-gray-900 dark:text-white\">Admin Panel</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(UserIcon), { class: "w-6 h-6 text-purple-600 dark:text-purple-400" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(currentAdminUser)?.displayName || 'Admin User'), 1),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(currentAdminUser)?.role || 'Administrator'), 1)
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationItems.value, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.id,
                type: "button",
                onClick: ($event: any) => (activeSection.value = item.id),
                "aria-current": activeSection.value === item.id ? 'page' : undefined,
                class: _normalizeClass([
              'w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors',
              activeSection.value === item.id
                ? 'bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
            ])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5 mr-3" })),
                _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                (item.badge)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.badge), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_25))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "px-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider" }, " Quick Actions ", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showUploadModal.value = true)),
                class: "w-full flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              }, [
                _createVNode(_unref(PlusIcon), { class: "w-5 h-5 mr-3" }),
                _cache[19] || (_cache[19] = _createTextVNode(" Upload Wallpaper ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCategoryModal.value = true)),
                class: "w-full flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              }, [
                _createVNode(_unref(FolderPlusIcon), { class: "w-5 h-5 mr-3" }),
                _cache[20] || (_cache[20] = _createTextVNode(" Add Category ", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            type: "button",
            onClick: handleSignOut,
            class: "w-full flex items-center px-3 py-2 text-sm font-medium text-red-600 dark:text-red-400 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
          }, [
            _createVNode(_unref(ArrowRightStartOnRectangleIcon), { class: "w-5 h-5 mr-3" }),
            _cache[22] || (_cache[22] = _createTextVNode(" Sign Out ", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sidebarOpen.value = true)),
              "aria-label": "Open sidebar",
              "aria-controls": "admin-sidebar",
              "aria-expanded": sidebarOpen.value,
              class: "lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
            }, [
              _createVNode(_unref(Bars3Icon), { class: "w-6 h-6" })
            ], 8, _hoisted_34),
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_35, _toDisplayString(currentSectionTitle.value), 1),
              _createElementVNode("p", _hoisted_36, _toDisplayString(currentSectionDescription.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", _hoisted_38, [
              _createVNode(_unref(BellIcon), { class: "w-6 h-6" })
            ]),
            _createVNode(_unref(SwitchGroup), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_unref(SwitchLabel), { class: "sr-only" }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("Toggle theme", -1)
                    ])),
                    _: 1,
                    __: [24]
                  }),
                  _createVNode(_unref(Switch), {
                    modelValue: isDark.value,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((isDark).value = $event)),
                      toggleTheme
                    ],
                    class: _normalizeClass([
                  isDark.value ? 'bg-purple-600' : 'bg-gray-200',
                  'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2'
                ])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                    isDark.value ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                  ])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      isDark.value ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in',
                      'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                    ]),
                          "aria-hidden": "true"
                        }, [
                          _createVNode(_unref(SunIcon), { class: "h-3 w-3 text-gray-400" })
                        ], 2),
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      isDark.value ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out',
                      'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                    ]),
                          "aria-hidden": "true"
                        }, [
                          _createVNode(_unref(MoonIcon), { class: "h-3 w-3 text-purple-600" })
                        ], 2)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "class"])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_40, [
        (activeSection.value === 'dashboard')
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(_unref(WallpaperStats)),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_unref(BlogStatsWidget), {
                  onNavigate: _cache[6] || (_cache[6] = ($event: any) => (activeSection.value = $event)),
                  onCreatePost: handleCreatePost,
                  onViewBlog: handleViewBlog
                }),
                _createVNode(_unref(TopWallpapersWidget)),
                _createVNode(_unref(RecentActivityWidget))
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-4" }, "Quick Actions", -1)),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (showUploadModal.value = true)),
                      class: "flex items-center justify-center px-4 py-3 bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors"
                    }, [
                      _createVNode(_unref(PlusIcon), { class: "w-5 h-5 mr-2" }),
                      _cache[25] || (_cache[25] = _createTextVNode(" Upload Wallpaper ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (showCategoryModal.value = true)),
                      class: "flex items-center justify-center px-4 py-3 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors"
                    }, [
                      _createVNode(_unref(FolderPlusIcon), { class: "w-5 h-5 mr-2" }),
                      _cache[26] || (_cache[26] = _createTextVNode(" Add Category ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (activeSection.value = 'wallpapers')),
                      class: "flex items-center justify-center px-4 py-3 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 rounded-lg hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors"
                    }, [
                      _createVNode(_unref(PhotoIcon), { class: "w-5 h-5 mr-2" }),
                      _cache[27] || (_cache[27] = _createTextVNode(" Manage Wallpapers ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (activeSection.value = 'analytics')),
                      class: "flex items-center justify-center px-4 py-3 bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300 rounded-lg hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors"
                    }, [
                      _createVNode(_unref(ChartBarIcon), { class: "w-5 h-5 mr-2" }),
                      _cache[28] || (_cache[28] = _createTextVNode(" View Analytics ", -1))
                    ])
                  ])
                ]),
                _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 shadow rounded-lg p-6\"><h3 class=\"text-lg font-medium text-gray-900 dark:text-white mb-4\">System Status</h3><div class=\"space-y-3\"><div class=\"flex items-center justify-between\"><span class=\"text-sm text-gray-600 dark:text-gray-400\">Database Status</span><span class=\"inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300\"><div class=\"w-2 h-2 bg-green-400 rounded-full mr-1\"></div> Online </span></div><div class=\"flex items-center justify-between\"><span class=\"text-sm text-gray-600 dark:text-gray-400\">Storage Status</span><span class=\"inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300\"><div class=\"w-2 h-2 bg-green-400 rounded-full mr-1\"></div> Healthy </span></div><div class=\"flex items-center justify-between\"><span class=\"text-sm text-gray-600 dark:text-gray-400\">CDN Status</span><span class=\"inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300\"><div class=\"w-2 h-2 bg-green-400 rounded-full mr-1\"></div> Active </span></div><div class=\"flex items-center justify-between\"><span class=\"text-sm text-gray-600 dark:text-gray-400\">Last Backup</span><span class=\"text-xs text-gray-500 dark:text-gray-400\">2 hours ago</span></div></div></div>", 1))
              ])
            ]))
          : _createCommentVNode("", true),
        (activeSection.value === 'wallpapers')
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              (_openBlock(), _createBlock(_unref(WallpaperManagement), { key: wallpaperManagementKey.value }))
            ]))
          : _createCommentVNode("", true),
        (activeSection.value === 'categories')
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createVNode(_unref(CategoryManagement))
            ]))
          : _createCommentVNode("", true),
        (activeSection.value === 'users')
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createVNode(_unref(AdminUserManagement))
            ]))
          : _createCommentVNode("", true),
        (activeSection.value === 'blog')
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createVNode(_unref(BlogManagement))
            ]))
          : _createCommentVNode("", true),
        (activeSection.value === 'analytics')
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[31] || (_cache[31] = [
              _createElementVNode("div", { class: "bg-white dark:bg-gray-800 shadow rounded-lg p-6" }, [
                _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-4" }, "Analytics Dashboard"),
                _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "Advanced analytics and reporting features coming soon...")
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (activeSection.value === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[32] || (_cache[32] = [
              _createElementVNode("div", { class: "bg-white dark:bg-gray-800 shadow rounded-lg p-6" }, [
                _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-4" }, "Application Settings"),
                _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "System configuration and settings management coming soon...")
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    (showUploadModal.value)
      ? (_openBlock(), _createBlock(_unref(WallpaperUploadModal), {
          key: 0,
          isOpen: showUploadModal.value,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (showUploadModal.value = false)),
          onUploadSuccess: handleUploadSuccess
        }, null, 8, ["isOpen"]))
      : _createCommentVNode("", true),
    (showCategoryModal.value)
      ? (_openBlock(), _createBlock(_unref(CategoryModal), {
          key: 1,
          isOpen: showCategoryModal.value,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (showCategoryModal.value = false)),
          onSuccess: handleCategorySuccess
        }, null, 8, ["isOpen"]))
      : _createCommentVNode("", true)
  ]))
}
}

})